module.exports = __webpack_public_path__ + "assets/img/operaterule_step1.7c6186f5.png";